module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = 197
// module chunks = 1